import React from 'react'
import { useFetch, useForm } from '../../../../../../../../hooks'
import Buttons from '../../../../../../../../modules/Buttons'
import Button from '../../../../../../../../components/inputs/Button'
import { FormHeader, Form } from '../../../../../../../../modules/Form/styled'
import { pathOr } from 'ramda'
import { toast } from 'react-toastify'

const FormRemoveBiosensor = ({ cowid, header, biosensor, buttons, onClickCancel, refetchCow }) => {

    const { fetching, doFetch } = useFetch({
        url: `/rpc/remove_${biosensor.name}`,
        method: 'POST'
    })

    const removeBiosensor = async () => {
        const response = await doFetch({
            data: {
                cowid: cowid,
                serial_: biosensor.serial
            }
        })

        const isError = pathOr(false, ['error'], response);
        const message = pathOr(null, ['msg'], response);
        if (isError) {
            message && toast.error(message);
        } else {
            message && toast.success(message);
            onClickCancel()
            await refetchCow({ loader: true })
        }
    }

    const { handleSubmit } = useForm({
        callback: removeBiosensor
    })

    return (
        <Form onSubmit={handleSubmit}>
            <FormHeader>
                {header}
            </FormHeader>
            <Buttons>
                <Button
                    type='submit'
                    fullWidth
                    red
                    disabled={fetching}
                >
                    {buttons.submit}
                </Button>
                <Button
                    type='button'
                    fullWidth
                    onClick={onClickCancel}
                >
                    {buttons.cancel}
                </Button>
            </Buttons>
        </Form>
    )
}

export default FormRemoveBiosensor
